import { logError, trackBusinessError } from './sentry';

// 중요한 에러 발생 시 관리자에게 알림톡 전송
export const sendErrorNotification = async (
  error: Error, 
  context: any,
  errorType: 'critical' | 'warning' | 'info' = 'critical'
) => {
  // 프로덕션 환경이고 중요한 에러인 경우에만 알림톡 전송
  if (import.meta.env.PROD && shouldNotifyError(error, errorType)) {
    try {
      await fetch('https://us-central1-refurb-buy.cloudfunctions.net/api/api/alerts/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          application_id: 'SYSTEM_ERROR',
          phone_number: '01012345678', // 관리자 번호 (실제 번호로 변경 필요)
          user_name: '시스템관리자',
          device_name: `${errorType.toUpperCase()} ERROR`,
          apply_date: new Date().toISOString().split('T')[0],
          event: '시스템_에러_알림',
          error_details: {
            message: error.message,
            stack: error.stack?.substring(0, 200), // 스택 트레이스 일부만
            context: JSON.stringify(context).substring(0, 300),
            timestamp: new Date().toISOString(),
            url: window.location.href
          }
        })
      });
      
      console.log('🚨 관리자에게 에러 알림톡 전송됨');
    } catch (notifyError) {
      console.error('에러 알림 전송 실패:', notifyError);
      // 알림 전송 실패도 Sentry에 기록
      logError(notifyError as Error, {
        original_error: error.message,
        notification_context: context
      });
    }
  }
};

const shouldNotifyError = (error: Error, errorType: string): boolean => {
  // critical 에러만 알림톡 전송
  if (errorType !== 'critical') return false;
  
  // 중요한 에러 패턴들
  const criticalErrors = [
    'payment', '결제',
    'application_submit', '신청서',
    'auth_failure', '인증',
    'database', 'firestore',
    'biztalk', '알림톡'
  ];
  
  const errorMessage = error.message.toLowerCase();
  return criticalErrors.some(pattern => 
    errorMessage.includes(pattern.toLowerCase())
  );
};

// 에러 레벨별 처리
export const handleError = (
  error: Error,
  context: Record<string, any>,
  level: 'critical' | 'warning' | 'info' = 'warning'
) => {
  // 모든 에러는 Sentry에 기록
  logError(error, { ...context, error_level: level });
  
  // 비즈니스 에러로 분류
  if (context.business_type) {
    trackBusinessError(
      context.business_type,
      error.message,
      context
    );
  }
  
  // critical 에러는 관리자에게 알림
  if (level === 'critical') {
    sendErrorNotification(error, context, level);
  }
  
  // 개발 환경에서는 콘솔에 상세 출력
  if (import.meta.env.DEV) {
    console.group(`🔥 ${level.toUpperCase()} ERROR`);
    console.error('Error:', error);
    console.error('Context:', context);
    console.groupEnd();
  }
}; 